import Catalogue from "./Catalogue";
import Nominal from "./Nominal";

const ContactCatalogue = ({ catalogue = false, nominal = false, notes = false } = {}) => `
  id
  ${
    catalogue
      ? `catalogue {
      ${Catalogue}
    }`
      : ""
  }
  catalogueId
  contactId
  ${
    nominal
      ? `nominal {
      ${Nominal}
    }`
      : ""
  }
  nominalId
  ${notes ? "notes" : ""}
  updatedAt
`;

export default ContactCatalogue;
